import React from 'react'
import tw from 'tailwind-styled-components'
import {cn} from '@containers/html-utils'
import {BgOpacityContainer} from '../bg-opacity-container/bg-opacity-container'

const TwCell = tw.div<{
  $dimmed?: boolean
}>`
  w-28 
  h-28
  flex
  justify-center
  items-center
  rounded-full
  text-12
  border
  border-solid
  border-transparent
    ${p =>
      cn(
        p.$dimmed && 'text-obscure-old',
        !p.$dimmed && 'group-hover:border-action-hover'
      )}
`

const MONTH_GRID = (() => {
  const grid = []
  let line = []
  for (let i = 1; i <= 31; i++) {
    line.push(i)
    if (i % 7 === 0) {
      grid.push(line)
      line = []
    }
  }
  grid.push(line)
  return grid
})()

export const DaysOfMonthPicker = ({
  className,
  value,
  onChange,
  disabled
}: {
  value: number[]
  onChange: (days: number[]) => void
  className?: string
  disabled?: boolean
}) => {
  const toggleDaySelection = (day: number) => {
    if (disabled) {
      return
    }
    const selected = value.includes(day)
    const newValue = selected ? value.filter(v => v !== day) : [...value, day]
    newValue.length && onChange(newValue)
  }

  return (
    <div className={cn(className, 'select-none')}>
      {MONTH_GRID.map((days, rowIndex) => (
        <div key={rowIndex} className="flex">
          {days.map((day, i) => (
            <DayCell
              key={i}
              day={day}
              selected={value.includes(day)}
              onClick={() => toggleDaySelection(day)}
              disabled={disabled}
            />
          ))}
        </div>
      ))}
    </div>
  )
}

const DayCell = ({
  day,
  selected,
  onClick,
  disabled
}: {
  day: number
  selected: boolean
  onClick: () => void
  disabled?: boolean
}) => {
  if (disabled) {
    return (
      <div className="cursor-default w-28 h-28 group" onClick={onClick}>
        <TwCell $dimmed>{day}</TwCell>
      </div>
    )
  }

  const bgClassName = cn(
    selected && 'bg-action-default font-semibold rounded-r-full rounded-l-full'
  )
  return (
    <div className="cursor-pointer w-28 h-28 group" onClick={onClick}>
      <BgOpacityContainer
        bgColorClassName={bgClassName}
        bgOpacityClassName="opacity-40"
      >
        <TwCell>{day}</TwCell>
      </BgOpacityContainer>
    </div>
  )
}
